// Phase 10 — Notes module copy strings.

export const notes = {
  pageTitle: 'Notes',
  pageSubtitle: 'Quick notes and thoughts.',
  emptyTitle: 'No notes yet',
  emptyBody: 'Write your first note to get started.',
  loadingLabel: 'Loading notes…',
  errorTitle: 'Could not load notes',
  errorBody: 'Check your connection and try again.',
  retry: 'Retry',
  addLabel: 'New note',
  editLabel: 'Edit note',
  saveLabel: 'Save',
  deleteLabel: 'Delete',
  titleLabel: 'Title',
  bodyLabel: 'Body',
  tagsLabel: 'Tags',
  tagsHint: 'Comma-separated',
  deletedToast: 'Note deleted.',
  createdToast: 'Note saved.',
  updatedToast: 'Note updated.',
  dashboardTitle: 'Notes',
  dashboardThisWeek: (count: number) => `${count} note${count === 1 ? '' : 's'} this week`,
  dashboardEmpty: 'No notes this week',
} as const;
